export default __webpack_public_path__ + "media/images/calendar-35004ef3f5201a747de6f24d9fd5e218.svg";